module.exports = __webpack_public_path__ + "img/tu-1.924e9a8b.png";